import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class FuelService extends BaseService {

	constructor() {	
		super();
	}
	
	async getFuel(refType, unitId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/fuel-purchases/units/' + refType + '/' + unitId + params);		
		return data;		
	}
	
	exportFuel(refType, unitId, paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/fuel-purchases/units/' + refType + '/' + unitId + '/export' + params);		
	};	
	
	async getFuelRecord(recordId) {
		var data = await this.makeGETRequest('/api/resource/fuel-purchases/' + recordId);		
		return data;		
	}
	
	async saveFuel(fuel, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/fuel-purchases/' + fuel.recordId, fuel);
		} else {
			saved = await this.makePOSTRequest('/api/resource/fuel-purchases', fuel);
		}
		return saved;		
	}
	
	async transferToGPS(request) {	
		var result = await this.makePOSTRequest('/api/resource/fuel-purchases/transfer', request);
		return result;
	}	
	
	async reReferenceFuel(reRefRequest) {	
		var result = await this.makePUTRequest('/api/resource/fuel-purchases/re-reference', reRefRequest);
		return result;
	}	
	
	async timeshiftFuel(timeShiftRequest) {	
		var result = await this.makePUTRequest('/api/resource/fuel-purchases/timeshift', timeShiftRequest);
		return result;
	}	
	
	async matchUnreferenced(request) {	
		var result = await this.makePUTRequest('/api/resource/fuel-purchases/match-unreferenced', request);
		return result;
	}	
	
	async deleteFuel(fuelIds) {
		var data = await this.makeDELETERequest('/api/resource/fuel-purchases', fuelIds);		
		return data;		
	}
	
	async deleteBulkFuel(bulkRequest) {
		var data = await this.makeDELETERequest('/api/resource/fuel-purchases/bulk',  bulkRequest);		
		return data;		
	}
		
	
}


